// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { VisualizerProject, IVisualizerProject } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getRecentProjects(): ApiResult<VisualizerProject[]> {
	return get<IVisualizerProject[]>(`/api/visualizer/recent`).then(result => result === undefined ? undefined : result.map(o => new VisualizerProject(o)));
}

export async function saveProject(project: VisualizerProject): ApiResult<VisualizerProject> {
	return post<IVisualizerProject>(`/api/visualizer/project`, project).then(result => result === undefined ? undefined :  new VisualizerProject(result));
}

export async function getProjectById(id?: string): ApiResult<VisualizerProject> {
	return get<IVisualizerProject>(`/api/visualizer/${ id }`).then(result => result === undefined ? undefined :  new VisualizerProject(result));
}

export async function deleteProject(id?: string): ApiResult<undefined> {
	return del(`/api/visualizer/${ id }`);
}
